import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
 
const Animation = () => {
  return (
    <div>
<DotLottieReact
      src="https://lottie.host/ff9ee845-39c7-428e-a925-2cecbdf56867/s94yD5YQss.lottie"
      loop
      autoplay
    />
    </div>
  )
}

export default Animation
